import { atomWithHash } from '@/atoms/atomWithHash';
import { atomWithStorage, createJSONStorage } from 'jotai/utils';

export const importedTemplateIdAtom = atomWithHash<string | null>(
  'importedTemplateId',
  null,
  {
    setHash: 'replaceState',
  }
);

const sessionStorageForTemplateId = createJSONStorage<string | null>(
  () => sessionStorage
);

/**
 * Persists the community template id a visitor wanted to import across the
 * signup/login flow. URL fragments are not reliably preserved through the
 * Kinde/Auth0 OAuth roundtrip, so we use sessionStorage (mirroring the
 * shared-template pattern in `pendingSharedTemplateAtom`).
 */
export const pendingCommunityTemplateIdAtom = atomWithStorage<string | null>(
  'heidi-pending-community-template-id',
  null,
  sessionStorageForTemplateId
);
